import { FlowsFIRenewalProductSelectSectionModel } from "./flows-fi-renewal-product-select-section.model";

export namespace FlowsFIRenewalProductSelectSectionAction {
  export class Focused {
    static readonly type = "[FlowsFIRenewalProductSelectSection] Focused ";
    constructor(public payload: FlowsFIRenewalProductSelectSectionModel) {}
  }

  export class Fetch {
    static readonly type = "[FlowsFIRenewalProductSelectSection] Fetch";
    constructor() {}
  }
  export class Loading {
    static readonly type = "[FlowsFIRenewalProductSelectSection] Loading ";
  }

  export class Section {
    static readonly type = "[FlowsFIRenewalProductSelectSection] Section";
    constructor(public activeSection: number) {}
  }
  export class Errorred {
    static readonly type = "[FlowsFIRenewalProductSelectSection] Errorred";
  }

  export class Completed {
    static readonly type = "[FlowsFIRenewalProductSelectSection] Completed ";
    constructor(public payload: FlowsFIRenewalProductSelectSectionModel) {}
  }
  export class Disabled {
    static readonly type = "[FlowsFIRenewalProductSelectSection] Disabled";
  }
}
